import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { LevelFormValues } from "src/models/Level.model";
import Level from "../Layouts/LevelForm";
import { useAddLevelMutation } from "src/services/LevelService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddLevelWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const [addLevel] = useAddLevelMutation();

  const initialValues: LevelFormValues = {
    levelName: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    levelName: string().required("Please enter level name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: LevelFormValues,
    { setSubmitting, resetForm }: FormikHelpers<LevelFormValues>
  ) => {
    addLevel(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Level formikProps={formikProps} onClose={onClose} formType="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddLevelWrapper;
